import { FlexSpinner } from 'components'
import { useAuthContext } from 'hooks/useAuthContext'
import { UserRole } from 'model'
import * as React from 'react'
import { AccessDenied } from './AccessDenied'

interface ViewAuthorizerProps {
  roles: UserRole[]
}

export const ViewAuthorizer: React.FC<ViewAuthorizerProps> = ({
  roles,
  children,
}) => {
  const auth = useAuthContext()
  const isAuthorized = auth.hasUserRole(roles)

  return (
    <FlexSpinner loading={!auth}>
      {isAuthorized ? children : <AccessDenied />}
    </FlexSpinner>
  )
}
